import * as actionTypes from './actionTypes';

export const openModal = (name, payload) => ({
  type: actionTypes.MODAL_OPEN,
  name,
  payload,
});

export const closeModal = (name) => ({
  type: actionTypes.MODAL_CLOSE,
  name,
});

export const closeAllModals = () => ({
  type: actionTypes.MODAL_CLOSE_ALL,
});
